import debounce from 'lodash/debounce';

export const undoRedo = {
  data: () => ({
    history: [],
    currentIndex: -1,
    state: null,
  }),
  methods: {
    clearUndoRedo() {
      this.history = [];
      this.currentIndex = -1;
      this.state = null;
    },
    updateUndoRedo: debounce(function (newState) {
      if (this.state && JSON.stringify(newState) === JSON.stringify(this.state)) {
        return;
      }
      if (this.currentIndex + 1 < this.history.length) {
        this.history.splice(this.currentIndex + 1);
      }
      this.state = newState;
      this.history.push(this.state);
      this.currentIndex++;
    }, 500),
    undo() {
      const prevState = this.history[this.currentIndex - 1];
      if (!prevState) {
        return;
      }
      this.state = prevState;
      this.currentIndex--;
    },
    redo() {
      const nextState = this.history[this.currentIndex + 1];
      if (!nextState) {
        return;
      }
      this.state = nextState;
      this.currentIndex++;
    },
  },
  computed: {
    canUndo() {
      return this.currentIndex > 0;
    },
    canRedo() {
      return this.currentIndex < this.history.length - 1;
    },
  },
};
